module.exports = __webpack_public_path__ + "img/demo2.33e62996.png";